import RegisterContent from "../components/AuthContent/RegisterContent";

const Login = () => {

    return (
        <>
            <RegisterContent/>
        </>
    )
}

export default Login;